import React from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react';
import { IntlShape } from 'react-intl';
import { ArtifactType, IArtifactDTO } from '../../../../../../api/artifacts.dao';
import { artifactStatusLabel, artifactStyleByStatus } from '../../../../../../constants/artifacts.constants';
import { ArtifactPopover } from '../artifact-popover/artifact-popover.container';
import ArtifactNotesWrapper from '../artifact-notes/artifact-notes-wrapper';
import { ArtifactLinkWrapper } from '../artifact-link/artifact-link-wrapper';
import ArtifactsViewModel from '../../artifacts.viewmodel';
import { ArtifactItemActionButton } from './artifact-item-action-button';

export interface IMeetingArtifactItemProps {
    intl: IntlShape;
    artifact: IArtifactDTO;
    downloadArtifactPermission: boolean;
    deleteArtifactPermission: boolean;
    deleteArtifactDownloadLinkPermission: boolean;
    colspan?: number;
    renderInTableRow?: boolean;
    meetingId: number;
    vm: ArtifactsViewModel;
}

const ArtifactItem = observer(({
    artifact,
    intl,
    colspan,
    renderInTableRow,
    downloadArtifactPermission,
    deleteArtifactPermission,
    meetingId,
    deleteArtifactDownloadLinkPermission,
    vm,
}: IMeetingArtifactItemProps) => {
    if (!artifact) return null;

    const {
        assetStatus,
        assetType,
        note,
    } = artifact;


    const isPassportReplayType = assetType === ArtifactType.PASSPORT_REPLAY;

    return renderInTableRow
        ? <>
                <td className='hoverable artifact-popover-item'>
                    <ArtifactPopover
                        artifact={artifact}
                        deleteArtifactPermission={deleteArtifactPermission}
                        onDeleteArtifact={vm.onDeleteArtifact}
                        onPreviewArtifact={vm.onOpenKnovioPreviewLinkPopover.bind(this, meetingId, artifact.assetMetadataId)}
                        meetingId={meetingId}
                    />
                </td>
                <td className={cn('hoverable', artifactStyleByStatus[assetStatus])}>
                    {artifactStatusLabel[assetStatus]}
                </td>
                <td className='hoverable'>
                    {!isPassportReplayType &&
                        <ArtifactLinkWrapper
                            artifact={artifact}
                            createLink={vm.createArtifactDownloadLink}
                            onDeleteArtifactDownloadLink={vm.onDeleteArtifactDownloadLink}
                            deleteArtifactDownloadLinkPermission={deleteArtifactDownloadLinkPermission}
                        />
                    }
                </td>
                <ArtifactNotesWrapper
                    note={note}
                    artifactId={artifact.assetMetadataId}
                    onUpdateArtifactNotes={vm.updateArtifactNotesById}
                />
                <ArtifactItemActionButton
                    intl={intl}
                    artifact={artifact}
                    downloadArtifactPermission={downloadArtifactPermission}
                    meetingId={meetingId}
                    onDownloadSingleArtifact={vm.onDownloadSingleArtifact}
                    openPublishArtifactPopover={vm.openPublishArtifactPopover}
                    onOpenKnovioPreviewLinkPopover={vm.onOpenKnovioPreviewLinkPopover}
                />
            </>
        : <tr className='meeting-artifact-list-item'>
            <td colSpan={colspan}></td>
            <td className='hoverable artifact-popover-item'>
                <ArtifactPopover
                    artifact={artifact}
                    deleteArtifactPermission={deleteArtifactPermission}
                    onDeleteArtifact={vm.onDeleteArtifact}
                    onPreviewArtifact={vm.onOpenKnovioPreviewLinkPopover.bind(this, meetingId, artifact.assetMetadataId)}
                    meetingId={meetingId}
                />
            </td>
            <td className={cn('hoverable', artifactStyleByStatus[assetStatus])}>
                {artifactStatusLabel[assetStatus]}
            </td>
            <td className='hoverable'>
                {!isPassportReplayType &&
                    <ArtifactLinkWrapper
                        artifact={artifact}
                        createLink={vm.createArtifactDownloadLink}
                        onDeleteArtifactDownloadLink={vm.onDeleteArtifactDownloadLink}
                        deleteArtifactDownloadLinkPermission={deleteArtifactDownloadLinkPermission}
                    />
                }
            </td>
            <ArtifactNotesWrapper
                note={note}
                artifactId={artifact.assetMetadataId}
                onUpdateArtifactNotes={vm.updateArtifactNotesById}
            />
            <ArtifactItemActionButton
                intl={intl}
                artifact={artifact}
                downloadArtifactPermission={downloadArtifactPermission}
                meetingId={meetingId}
                onDownloadSingleArtifact={vm.onDownloadSingleArtifact}
                openPublishArtifactPopover={vm.openPublishArtifactPopover}
                onOpenKnovioPreviewLinkPopover={vm.onOpenKnovioPreviewLinkPopover}
            />
        </tr>;
});

export default ArtifactItem;
